export const PROFIT_TABLE_HELP_ARTICLE_URL =
	'https://support.scoro.com/hc/en-us/articles/12162946143757-Project-view#h_01HGD775VAS5ZVZPCBACZ0H0M5';
